import React from "react";
import "./OurDetails.css";
import DetailsImage from "../../../../assets/images/our-details-img.png";
import DetailsDots from "../../../../assets/images/aboutus-dots.png";
const OurDetails = () => {
  return (
    <div className="our__details_section">
      <img src={DetailsDots} alt="" className="details__section_dots" />
      <div className="details__section_left">
        <img src={DetailsImage} alt="" className="details__section_img" />
      </div>
      <div className="details__section_right">
        <div className="details__secleft_heading">
          Serene Tax is one of the few Service Certifying Acceptance Agents in
          United States Internal Revenue Services
        </div>
        <div className="details__secleft_description">
          <p>
            One of our key objectives is to keep communication consistent with
            our clients on a regular basis and offer extended hours of business.
            We put in special hours to go way and beyond as we consider our
            clients like an extended family.
          </p>
          <p>
            Our firm has been built on the grounds of attempting to resolve what
            may have seemed impossible. This, we have learnt is because we have
            an extraordinary team that set ambitious goals and has astonishing
            breakthroughs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OurDetails;
